import TeamCard from './TeamCard';
import { TEAM_SECTIONS } from '../../data/teamMembers';
import './TeamSections.css';

function TeamSection({ section }) {
  const { id, title, members } = section;
  const headingId = `team-${id}`;

  return (
    <section className="team-section" aria-labelledby={headingId}>
      <div className="container">
        <h2 id={headingId} className="team-section__title">
          {title}
        </h2>
        <ul className="team-grid">
          {members.map((member) => (
            <TeamCard key={member.id} member={member} />
          ))}
        </ul>
      </div>
    </section>
  );
}

export default function TeamSections() {
  return (
    <>
      {TEAM_SECTIONS.map((section) => (
        <TeamSection key={section.id} section={section} />
      ))}
    </>
  );
}
